import { render } from "./cookie-consent-banner.vue?vue&type=template&id=f963544c&ts=true"
import script from "./cookie-consent-banner.ts?vue&type=script&lang=ts&external"
export * from "./cookie-consent-banner.ts?vue&type=script&lang=ts&external"

import "./cookie-consent-banner.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__